export default __webpack_public_path__ + "static/media/left-arrow.icon.c8e65279.svg";